['planet:smart-cart:add', 'planet:smart-cart:change'].forEach(eventName => {
  window.addEventListener(eventName, async () => {
    try {
      console.log("SmartCart event triggered:", eventName);

      const response = await fetch('?section_id=helper-cart');
      if (!response.ok) throw new Error('Section fetch failed');

      const text = await response.text();
      const sectionDOM = new DOMParser().parseFromString(text, 'text/html');

      // Replace main cart form
      const newCartForm = sectionDOM.getElementById('AjaxCartForm');
      const currentCartForm = document.getElementById('AjaxCartForm');
      if (newCartForm && currentCartForm) {
        currentCartForm.innerHTML = newCartForm.innerHTML;
      }

      // Replace subtotal
      const newSubtotal = sectionDOM.getElementById('AjaxCartSubtotal');
      const currentSubtotal = document.getElementById('AjaxCartSubtotal');
      if (newSubtotal && currentSubtotal) {
        currentSubtotal.innerHTML = newSubtotal.innerHTML;
      }

      // Replace header cart count
      const newCount = newCartForm?.querySelector('[data-cart-count]')?.textContent;
      if (newCount) {
        document.querySelectorAll('[data-header-cart-count]').forEach(el => {
          el.textContent = newCount;
        });
      }

      // Replace header cart total
      const newTotal = newCartForm?.querySelector('[data-cart-total]')?.textContent;
      if (newTotal) {
        document.querySelectorAll('[data-header-cart-total]').forEach(el => {
          el.textContent = newTotal;
        });
      }

    } catch (error) {
      console.error('Failed to update cart UI:', error);
    }
  });
});